/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeJsonWebKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeJsonWebKeyRequest = {
  /**
   * The ID of the key to revoke.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type RevokeJsonWebKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeJsonWebKeySecurity$outboundSchema: z.ZodMiniType<
  RevokeJsonWebKeySecurity$Outbound,
  RevokeJsonWebKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeJsonWebKeySecurityToJSON(
  revokeJsonWebKeySecurity: RevokeJsonWebKeySecurity,
): string {
  return JSON.stringify(
    RevokeJsonWebKeySecurity$outboundSchema.parse(revokeJsonWebKeySecurity),
  );
}

/** @internal */
export type RevokeJsonWebKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeJsonWebKeyRequest$outboundSchema: z.ZodMiniType<
  RevokeJsonWebKeyRequest$Outbound,
  RevokeJsonWebKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function revokeJsonWebKeyRequestToJSON(
  revokeJsonWebKeyRequest: RevokeJsonWebKeyRequest,
): string {
  return JSON.stringify(
    RevokeJsonWebKeyRequest$outboundSchema.parse(revokeJsonWebKeyRequest),
  );
}
